import { ElementType } from 'react';
import { staticPaths } from '@finsight/urls/static';
import CFR_URL from '@/creditflowresearch/Router/urlConstants';
import IconPrice from '@dealroadshow/uikit-icon/IconPrice';
import IconLayersGroup from '@dealroadshow/uikit-icon/IconLayersGroup';

export interface ILinkConfig {
  url: string,
  dataTest: string,
  label: string,
  IconLink?: ElementType,
}

const linksConfig: ILinkConfig[] = [
  {
    url: CFR_URL.PRICING,
    dataTest: 'pricing',
    IconLink: IconPrice,
    label: 'Pricing',
  },
  {
    url: staticPaths.getSolutionsPath(),
    dataTest: 'solutions',
    IconLink: IconLayersGroup,
    label: 'Solutions',
  },
];

export default linksConfig;
